<template>
    <div>
        <img src="img/banner-4.jpg" class="nark img-banner">
        <sub-navigation :data='NewsNav'></sub-navigation>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import SubNavigation from '@/components/pc/SubNavigation'
export default {
    components:{
      SubNavigation
    } ,
    computed:{
        ...mapState({
            NewsNav:state=>state.share.NewsNav
        })
    },
}
</script>

<style>

</style>